import React, { ReactNode } from 'react'

import { CenteredLoading } from '../CenteredLoading/CenteredLoading'
interface DataAndLoading {
  data: string[] | undefined
  loading: boolean
}

interface Props {
  dataAndLoading: DataAndLoading[]
  children?: ReactNode
}

export const LoadingMultipleArrayDataQueriesWrapper = ({
  dataAndLoading,
  children
}: Props) => {
  return (
    <>
      {dataAndLoading.some((d) => d.loading) && <CenteredLoading />}
      {(dataAndLoading.every((d) => d.data) ||
        dataAndLoading.some((d) => d.data && d.data.length === 0)) &&
        children}
    </>
  )
}
